const LOCALE_FALLBACKS = {
  'no-NO': ['no-NO', 'nb', 'nn', 'da'],
};
const fractionDigits = {
  MIN: 2,
  MAX: 2,
};
const format = (value, { locale }) => {
  const locales = LOCALE_FALLBACKS[locale] || locale;
  const formatter = new Intl.NumberFormat(locales, {
    minimumFractionDigits: fractionDigits.MIN,
    maximumFractionDigits: fractionDigits.MAX,
  });
  return formatter.format(value);
};
const currency = {
  format,
};

export { currency as c, format as f };
